<template>
    <div>
        <el-tooltip placement="top">
            <div slot="content" :style="{maxWidth: '400px',maxHeight: '300px', overflow: 'auto'}">
                <div v-html="msg"></div>
            </div>
            <i class="el-icon-question" style="cursor: pointer; margin-left: 3px;"></i>
        </el-tooltip>
    </div>
</template>
<script>
export default {
  name: 'oppo_stepsPlan_tips',
  data() {
      return {
          msg: '信息'
      }
  }
}
</script>
